export default window.__litium.constants;

export const OFFER_CART_LOAD_ERROR = 'OFFER_CART_LOAD_ERROR';
export const OFFER_CART_RECEIVE = 'OFFER_CART_RECEIVE';
export const OFFER_CART_SHOW_INFO = 'OFFER_CART_SHOW_INFO';

export const OFFER_CHECKOUT_SUBMIT = "OFFER_CHECKOUT_SUBMIT";
export const OFFER_CHECKOUT_SUBMIT_ERROR = "OFFER_CHECKOUT_SUBMIT_ERROR";
export const OFFER_CHECKOUT_SET_CUSTOMER_INFO = "OFFER_CHECKOUT_SET_CUSTOMER_INFO";
export const OFFER_CHECKOUT_ACCEPT_TERMS_OF_CONDITION = "OFFER_CHECKOUT_ACCEPT_TERMS_OF_CONDITION";
export const OFFER_CHECKOUT_SET_SELECTED_COMPANY_ADDRESS = "OFFER_CHECKOUT_SET_SELECTED_COMPANY_ADDRESS";
export const OFFER_CHECKOUT_SET_SELECTED_DEPOT = "OFFER_CHECKOUT_SET_SELECTED_DEPOT";
export const OFFER_CHECKOUT_SET_ORDER_NOTE = "OFFER_CHECKOUT_SET_ORDER_NOTE";